import React from 'react';
import classnames from 'classnames';

import { formatBytes } from './utils';


const DropzonePreviewItem = (props: any) => {
  const isRejected = Boolean(props.reason);
  const fileName = <h4 className="mb-1 text-truncate">{props.name}</h4>;
  console.log(props.size);
  return (
    <div className={classnames('row align-items-center', props.className)}>
      <div className="col-auto">
        {props.Preview
          && (
            <props.Preview
              size="sm"
              rounded={false}
              cover={false}
              subject={{ name: props.name, avatar: '/static/img/file-text.svg' }}
            />
          )}
      </div>
      <div className="col ml-n3 w-50">
        {props.url
          ? (
            <a href={process.env.BASE_API_URL + props.url} target="_blank">
              {fileName}
            </a>
          )
          : fileName}
        <p className="small text-muted mb-0">
          <strong className={classnames({ 'text-danger': isRejected })}>
            {!isNaN(Number(props.size)) ? formatBytes(props.size) : props.size /* eslint-disable-line */ }
          </strong>
          {isRejected && (
            <div className="invalid-feedback d-block m-0">
              <i className="fe fe-alert-triangle mr-2" aria-hidden="true" />
              {props.reason}
            </div>
          )}
        </p>
      </div>
      <div className="col-auto">
        {props.removable && (
          <a href="#" className="text-secondary" onClick={props.handleRemove} role="button">
            <i className="fe fe-trash" />
          </a>
        )}
        {props.children && !props.removable && (
          <div className="dropdown">
            <a
              href="#" className="dropdown-ellipses dropdown-toggle" role="button" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false"
            >
              <i className="fe fe-more-vertical" />
            </a>
            <div className="dropdown-menu dropdown-menu-right">
              {props.children}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

DropzonePreviewItem.defaultProps = {
  size: 0,
  name: '',
  className: '',
  removable: false,
};

export default DropzonePreviewItem;
